import styled from 'styled-components';

export const UiSessionReportPage = styled.div`
	display: block;
`;